import { AccountBasePage } from './AccountBasePage'

const Page: React.FC = () => {
  return <AccountBasePage funnelName="ps5" />
}

export default Page
